<template>
  <div class="six content">
    <div class="left-side slideUp">
      <router-link :to="{ name: 'ProjectFive' }">
        <img src="../assets/up-arrow.png" class="arrow arrow-up" />
      </router-link>
      <p class="notice-parragraph">
        💬 Usa las flechas para navegar entre mis proyectos
      </p>
      <h1>THE HANGMAN APP</h1>

      <p class="subtxt">Tecnologías usadas:</p>
      <ul class="technologies">
        <li>Java para Android</li>
      </ul>
      <a
        class="project-link"
        href="https://github.com/nicoleloupias/android-app"
        target="_blank"
        >Visitar en GitHub</a
      >
      <router-link :to="{ name: 'ProjectFive' }">
        <div class="MobileLink">
          <p>Anterior proyecto</p>
          <img src="../assets/up-arrow.png" class="MobileLinkDecor" />
        </div>
      </router-link>
      <router-link :to="{ name: 'ProjectOne' }">
        <img src="../assets/down-arrow.png" class="arrow arrow-down" />
        <div class="MobileLink">
          <p>Siguiente proyecto</p>
          <img src="../assets/down-arrow.png" class="MobileLinkDecor" />
        </div>
      </router-link>
    </div>

    <div class="img2 right-side">
      <img src="../assets/ahorcado.png" />
    </div>
  </div>
</template>

<script>
export default {
  name: "ProjectSix",
};
</script>

<style lang="scss" scoped>
$page_color: #305a47;
h1 {
  color: $page_color !important;
}
.img2 {
  img {
    height: 70%;
  }

  @media screen and (max-width: 1000px) {
    img {
      height: auto;
      width: 70%;
    }
  }
}

a.project-link::before {
  background-color: $page_color !important;
}

.technologies {
  margin-bottom: 50px;
}
</style>
